// extracted by mini-css-extract-plugin
export default {"index-bar":"IndexBar_index-bar__AvBOB"};